import { ErrorPage } from "./error-page";

export const SERVER_ERROR_DESCRIPTION =
  "서버 점검 또는 예상치 못한 부하로 인해 현재 서버 상태가 일시적으로 요청을 처리할 수 없습니다. 담당 팀에 연락하여 서비스 복구를 위해 노력하고 있습니다. ";

export const SERVER_ERROR_MAP: Record<number, { code: string; title: string }> = {
  500: { code: "Error 500", title: "Internal Server Error" },
  502: { code: "Error 502", title: "Bad Gateway" },
  503: { code: "Error 503", title: "Service Unavailable" },
};

interface ServerErrorPageProps {
  status?: 500 | 502 | 503;
}

export function ServerErrorPage({ status = 500 }: ServerErrorPageProps) {
  const { code, title } = SERVER_ERROR_MAP[status] ?? SERVER_ERROR_MAP[500];

  return (
    <ErrorPage
      code={code}
      title={title}
      description={SERVER_ERROR_DESCRIPTION}
      illustration="server"
    />
  );
}
